<template>
  <b-card title="Напоминалки об играх">
    <b-overlay :show="isLoading" rounded="sm">
      <b-alert v-if="!isLoading && rows.length === 0" show variant="warning">
        Нет актуальных напоминалок с опубликованным постом
      </b-alert>

      <b-table
          v-if="rows.length > 0"
          :items="rows"
          :fields="fields"
          responsive
          striped
          small
      >
        <template #cell(start_datetime)="data">
          {{ formatDateTime(data.item.start_datetime) }}
        </template>

        <template #cell(name)="data">
          <b-link :href="data.item.task_url" target="_blank">
            {{ data.item.name }}
          </b-link>
        </template>

        <template #cell(free_places)="data">
          {{ data.item.count }} / 4 (свободно {{ data.item.free_places }})
        </template>

        <template #cell(post_url)="data">
          <b-link :href="data.item.post_url" target="_blank">
            #{{ data.item.post_id }}
          </b-link>
        </template>

        <template #cell(actions)="data">
          <b-button
              variant="warning"
              size="sm"
              :disabled="revivingId === data.item.task_id"
              @click="revive(data.item)"
          >
            <span v-if="revivingId === data.item.task_id">
              <b-spinner small />
              Оживляю...
            </span>
            <span v-else>
              <feather-icon icon="ZapIcon" class="mr-50" />
              Оживить
            </span>
          </b-button>
        </template>
      </b-table>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BOverlay,
  BAlert,
  BSpinner,
  BLink,
} from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import store from '@/store'
import gameStoreModule from '@/views/game/gameStoreModule'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BOverlay,
    BAlert,
    BSpinner,
    BLink,
  },
  setup() {
    const STORE_MODULE_NAME = 'app-games'
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, gameStoreModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const toast = useToast()

    const isLoading = ref(false)
    const revivingId = ref(null)
    const rows = ref([])

    const fields = [
      { key: 'start_datetime', label: 'Когда' },
      { key: 'name', label: 'Игра' },
      { key: 'topic', label: 'Тема' },
      { key: 'pack_name', label: 'Пакет' },
      { key: 'free_places', label: 'Игроки' },
      { key: 'last_remind', label: 'Напоминание' },
      { key: 'post_url', label: 'Пост' },
      { key: 'actions', label: 'Действие' },
    ]

    const showToast = (title, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'danger' ? 'AlertTriangleIcon' : 'CheckCircleIcon',
          variant,
        },
      })
    }

    const errorMessage = (error, fallback) => (
      (error.response && error.response.data && error.response.data.message) || fallback
    )

    const formatDateTime = iso => new Date(iso).toLocaleString('ru-RU', {
      timeZone: 'Europe/Moscow',
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })

    const loadReminders = () => {
      isLoading.value = true
      store.dispatch('app-games/fetchGameReminders')
          .then(response => {
            rows.value = response.data.data
          })
          .catch(error => showToast(errorMessage(error, 'Ошибка загрузки напоминалок'), 'danger'))
          .finally(() => {
            isLoading.value = false
          })
    }

    const revive = item => {
      revivingId.value = item.task_id
      store.dispatch('app-games/reviveReminder', { id: item.task_id })
          .then(response => showToast(response.data.message || 'Напоминалка обновлена', 'success'))
          .catch(error => showToast(errorMessage(error, 'Ошибка оживления'), 'danger'))
          .finally(() => {
            revivingId.value = null
          })
    }

    loadReminders()

    return {
      isLoading,
      revivingId,
      rows,
      fields,
      formatDateTime,
      revive,
    }
  },
}
</script>
